import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'button', 'count'];

  connect() {
    this.update();
  }

  update() {
    if (!this.hasButtonTarget) return;

    const emails = [
      ...new Set(
        this.checkboxTargets
          .filter((checkbox) => checkbox.checked)
          .map((checkbox) => checkbox.value),
      ),
    ];
    const enabled = emails.length > 0;

    this.countTarget.textContent = String(emails.length);
    this.buttonTarget.href = enabled ? `mailto:${emails.join(',')}` : '#';
    this.buttonTarget.setAttribute('aria-disabled', String(!enabled));
    this.buttonTarget.classList.toggle('pointer-events-none', !enabled);
    this.buttonTarget.classList.toggle('text-black-300', !enabled);
    this.buttonTarget.classList.toggle('text-brand-1000', enabled);
  }
}
